// @flow
import React from 'react'
import { Stink } from 'components/Stink'
import styled from 'styled-components'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import './styles.scss'

export class Section5 extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    return <div className='section five'>
       <div className="wrapper">
        <h2>Das sind die beliebtesten Namen</h2>
        <div className='two-column'>
            <div className={'column left'} key={'left'}>
              <div className='txt'>
                Wenn es um die Namensfindung ihrer Hunde geht, sind Schweizerinnen und Schweizer kreativ. Die Mehrheit aller Namen kommt nur einmal vor und wird deshalb nicht in der Statistik erfasst. Auch Tiere ohne Namen (das gibt es) oder solche mit «technischen» Bezeichnungen (zum Beispiel Zahlen, das gibt es auch) werden hier nicht berücksichtigt. Trotzdem gibt es einige Namen, die sehr häufig vorkommen.
              </div>
              <div className="chart">
                <AutofitIFrame
                  src={'https://datawrapper.dwcdn.net/xIqbg/' + '?dark=' + String(this.props.colorMode === 'dark')}
                />
              </div>
            </div>

            <div className={'column right'} key={'right'}>
              <div className='txt'>
                Bei Hündinnen entpuppt sich Luna als mit Abstand beliebtester Name, dahinter folgen Kira und Nala. Erstaunlich: Alle Namen dieser Top Ten findet man auch in der <Stink href='246112984283'>Liste der beliebtesten Mädchennamen</Stink>. Bei den männlichen Hunden, auch Rüden genannt, ist das nur vereinzelt der Fall. Hier erinnern die beliebtesten Namen eher an Filmfiguren oder Comics.
              </div>
              <div className="chart">
                <AutofitIFrame
                  src={'https://datawrapper.dwcdn.net/dQJ4U/' + '?dark=' + String(this.props.colorMode === 'dark')}
                />
              </div>
            </div>
        </div>
      </div>
    </div>
  }
}
